import React from "react";
import styled from "styled-components";

import Layout from "@components/Layout";

import { Container } from "@styles/grid";
import BucketsAddForm from "./BucketsAddForm";

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 3rem 5.5rem 5.5rem;
`;

const BucketsAdd = () => {
  return (
    <Layout pageTitle="Add Bucket">
      <Container>
        <Content>
          <BucketsAddForm />
        </Content>
      </Container>
    </Layout>
  );
};

export default BucketsAdd;
